import request from "@/utils/request"

export default function getCardChangeLogByPage(params, pageNum = 1, size = 10) {
    return request({
        url: `/user/cardChangeLog/getCardChangeLogByPage/${pageNum}/${size}`,
        params
    })
}
